import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit, faXmark } from "@fortawesome/free-solid-svg-icons";
import styles from "./SapCodeBadge.module.scss";
import { SapCodeBadgeProps, useSapCodeBadge } from "./useSapCodeBadge";
import SapCodeEditPopup from "./SapCodeEditPopup";

export type { SapCodeBadgeProps };

export default function SapCodeBadge(props: SapCodeBadgeProps) {
    const { state, handlers, utilities } = useSapCodeBadge(props);
    const { value, isReadOnly } = props;

    // null = BE permission-hide; render nothing
    if (value === null) return null;

    // empty + read-only → nothing
    if (!value && isReadOnly) return null;

    const popup = (
        <SapCodeEditPopup
            isOpen={state.isSapEditOpen}
            initialValue={value ?? undefined}
            onSave={props.onSave}
            onClose={handlers.closeSapEdit}
        />
    );

    // empty + editable → "Add SAP Code" link
    if (!value) {
        return (
            <>
                <button type="button" className={styles.addLink} onClick={handlers.openSapEdit}>
                    {utilities.addLabel}
                </button>
                {popup}
            </>
        );
    }

    // truthy value
    return (
        <>
            <span className={styles.badge}>
                <span className={styles.label}>
                    SAP <span className={styles.code}>{value}</span>
                </span>
                {!isReadOnly && (
                    <>
                        <button
                            type="button"
                            className={styles.iconBtn}
                            onClick={handlers.openSapEdit}
                            aria-label="Edit SAP Code"
                        >
                            <FontAwesomeIcon icon={faEdit} />
                        </button>
                        <button
                            type="button"
                            className={`${styles.iconBtn} ${styles.removeBtn}`}
                            onClick={handlers.handleConfirmRemove}
                            aria-label="Remove SAP Code"
                        >
                            <FontAwesomeIcon icon={faXmark} />
                        </button>
                    </>
                )}
            </span>
            {popup}
        </>
    );
}
